// FIXME: Automatically disabled during ESLint config update
import z from "zod";

const type = z.literal("shift-time-proposal");

export const SHIFT_TIME_PROPOSAL_STATUS = {
  PROPOSED: "PROPOSED",
  CANCELLED: "CANCELLED",
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
  APPLIED: "APPLIED",
} as const;

export const shiftTimeProposalStatusSchema = z.nativeEnum(SHIFT_TIME_PROPOSAL_STATUS);

export const shiftTimeProposalRelationshipsSchema = z.object({
  shift: z.object({
    data: z.object({
      type: z.literal("shift"),
      id: z.string(),
    }),
  }),
  worker: z.object({
    data: z.object({
      type: z.literal("worker"),
      id: z.string(),
    }),
  }),
});

export const shiftTimeProposalAttributesSchema = z.object({
  status: shiftTimeProposalStatusSchema,
  proposedStartTime: z.string().datetime(),
  proposedEndTime: z.string().datetime(),
});

export const shiftTimeProposalDataSchema = z.object({
  type,
  id: z.string(),
  attributes: shiftTimeProposalAttributesSchema,
  relationships: shiftTimeProposalRelationshipsSchema,
});

export const getShiftTimeProposalByIdResponseSchema = z.object({
  data: shiftTimeProposalDataSchema,
});

export const getShiftTimeProposalsResponseSchema = z.object({
  data: z.array(shiftTimeProposalDataSchema),
});

export const createShiftTimeProposalRelationshipsSchema = z.object({
  shift: z.object({
    data: z.object({
      type: z.literal("shift"),
      id: z.string(),
    }),
  }),
});

export const createShiftTimeProposalAttributesSchema = z.object({
  proposedStartTime: z.string().datetime(),
  proposedEndTime: z.string().datetime(),
});

export const createShiftTimeProposalRequestSchema = z.object({
  data: z.object({
    type,
    attributes: createShiftTimeProposalAttributesSchema,
    relationships: createShiftTimeProposalRelationshipsSchema,
  }),
});

export const createShiftTimeProposalResponseSchema = z.object({
  data: shiftTimeProposalDataSchema,
});

export const updateShiftTimeProposalAttributesSchema = z.object({
  proposedStartTime: z.string().datetime().optional(),
  proposedEndTime: z.string().datetime().optional(),
});

export const updateShiftTimeProposalRequestSchema = z.object({
  data: z.object({
    type,
    id: z.string(),
    attributes: updateShiftTimeProposalAttributesSchema,
  }),
});

export const updateShiftTimeProposalResponseSchema = z.object({
  data: shiftTimeProposalDataSchema,
});
